// Class: motion.easing.Quart

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
function motion_easing__$Quart_QuartEaseIn() {return require("./../../motion/easing/_Quart/QuartEaseIn");}
function motion_easing__$Quart_QuartEaseInOut() {return require("./../../motion/easing/_Quart/QuartEaseInOut");}
function motion_easing__$Quart_QuartEaseOut() {return require("./../../motion/easing/_Quart/QuartEaseOut");}

// Constructor

var Quart = function(){}

// Meta

Quart.__name__ = ["motion","easing","Quart"];
Quart.__isInterface__ = false;
Quart.prototype = {
	
};
Quart.prototype.__class__ = Quart.prototype.constructor = $hxClasses["motion.easing.Quart"] = Quart;

// Init



// Statics


Quart.easeIn = new (motion_easing__$Quart_QuartEaseIn().default)()
Quart.easeInOut = new (motion_easing__$Quart_QuartEaseInOut().default)()
Quart.easeOut = new (motion_easing__$Quart_QuartEaseOut().default)()

// Export

exports.default = Quart;